import { createInstance } from 'i18next';
import HttpApi from 'i18next-http-backend';
import { captureException } from './sentryService.js';

const supportedLngs = [
    'bg-BG',
    'cs-CZ',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'el-GR',
    'en',
    'en-GB',
    'en-IE',
    'es-ES',
    'fi-FI',
    'fr-BE',
    'fr-CH',
    'fr-FR',
    'hr-HR',
    'hu-HU',
    'it-IT',
    'nl-NL',
    'nb-NO',
    'no-NO',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'ru-RU',
    'sk-SK',
    'sl-SI',
    'sv-SE',
    'zu',
];
const extractNamespace = () => {
    const nsRegex = /(zoo|bitiba)/;
    const ns = document.location.hostname.match(nsRegex) ?? ['zoo'];
    return (ns[0] === 'zoo' ? 'zooplus' : 'bitiba');
};
const TRANSLATION_FILE_RELATIVE_PATH = `zpp-assets/payment-frontend/locales/${extractNamespace()}`;
let instance;
let initializing = false;
const initializeI18n = async (shopBundle, locale, env) => {
    const cdnBaseURL = env === 'prod'
        ? 'https://cdn.public.zooplus.net/media'
        : 'https://cdn-dev.public.zooplus.net/media';
    if (instance) {
        return instance;
    }
    if (initializing) {
        return await new Promise((resolve) => waitForInstance(resolve));
    }
    initializing = true;
    const loadingInstance = createInstance();
    await loadingInstance.use(HttpApi).init({
        compatibilityJSON: 'v4',
        resources: {},
        partialBundledLanguages: true,
        backend: {
            loadPath: (lng) => {
                const lang = lng[0] === 'no-NO' ? 'nb-NO' : lng[0];
                return `${cdnBaseURL}/zpp-assets/payment-frontend/locales/${shopBundle}/${lang}.json`;
                // return `/${shopBundle}/${lang.replace('-', '_')}.json`; // Uncomment to use local translations
            },
            reloadInterval: 30 * 60 * 1000, //reload every 30 mins
        },
        react: {
            useSuspense: false,
        },
        interpolation: { escapeValue: false },
        lng: locale,
        load: 'currentOnly',
        ns: [],
        defaultNS: [],
        fallbackLng: 'zu',
        supportedLngs,
        debug: false, // set this to true to see your requests being logged
    });
    await loadingInstance.loadNamespaces([TRANSLATION_FILE_RELATIVE_PATH]);
    instance = loadingInstance;
    initializing = false;
    instance.on('failedLoading', (lng, ns, message) => {
        captureException(new Error(`Could not load ${lng} in ns ${ns}, error message: ${message}`));
    });
    return instance;
};
const waitForInstance = (resolve) => {
    if (instance) {
        resolve(instance);
    }
    else {
        setTimeout(() => waitForInstance(resolve), 100);
    }
};

export { TRANSLATION_FILE_RELATIVE_PATH, extractNamespace, initializeI18n, supportedLngs };
//# sourceMappingURL=i18nService.js.map
